// @ts-nocheck
import { BrowserRouter, createBrowserRouter, Route, Routes, RouterProvider } from 'react-router-dom';
import RequireAuth from './Auth';
import NotRequireAuth from './NotRequire';
import SVGFINDER from '../pages/SVGFINDER';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard.jsx';
import ChooseApp from '../pages/ChooseAppPage/ChooseApp';
import ThemeScreen from '../pages/ThemeScreen/index.jsx';
import PreLoader from '../components/ui/preLoader';
import Setup from '../pages/DashboardPages/Setup';
import allTabs from '../pages/DashboardTabs';
import ChangePasswordPage from '../pages/ChangePasswordPage';
import CheckMissingJson from '../pages/CheckMissingJson';
import DashboardLayout from './DashboardLayout';
import UserRegister from '../pages/UserRegister';
import ForgotPasswordComponent from '../pages/UserForgotPassword';
import SurveyManager from '../pages/DashboardPages/Surveys/SurveyManager';
import CreateApp from '../pages/CreateApp';
import Store from './Store';
import Survey from './Survey';
import SurveyRedirect from '../pages/DashboardPages/Surveys/SurveyRedirect';
import PaymentSuccess from '../pages/PaymentRedirects/PaymentSuccess';
import PaymentFailure from '../pages/PaymentRedirects/PaymentFailure';
const router = createBrowserRouter([{ path: '*', element: <Root /> }]);

const AppRouter = () => {
  return (
    <>
      <PreLoader />
      <RouterProvider router={router} />
    </>
  );
};

export default AppRouter;

function Root() {
  // 2️⃣ `BrowserRouter` component removed, but the <Routes>/<Route>
  // component below are unchanged
  return (
    <Routes>

      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-failure" element={<PaymentFailure />} />
      <Route element={<NotRequireAuth />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<UserRegister />} />
      </Route>
      <Route path="/forgotPassword" element={<ForgotPasswordComponent />} />
      <Route path="/changePassword" element={<ChangePasswordPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Survey />}>
          <Route path="/surveys" element={<SurveyRedirect></SurveyRedirect>} />
          <Route element={<Store />}>

            <Route path="/chooseApp" element={<ChooseApp />} />
            <Route path="/createapp" element={<CreateApp />} />

            <Route element={<DashboardLayout />}>
              <Route path="/theme/:id" element={<ThemeScreen />} />
              {process.env.REACT_APP_DEV_MODE && <Route path="/checkMissingJson" element={<CheckMissingJson />} />}
              {allTabs.map((tab, index) => {
                return <Route key={index} path={tab.pointTo} element={<Dashboard activeTab={tab}></Dashboard>} />;
              })}
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path="/*" element={<Login />} />
    </Routes>
  );
}
